/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateCustomQuestionMutationVariables = Types.Exact<{
  questionId: Types.Scalars['Int'];
  name?: Types.InputMaybe<Types.Scalars['String']>;
  choices?: Types.InputMaybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
}>;


export type UpdateCustomQuestionMutation = { updateCustomQuestion: { id: number, isUsed: boolean, name: string, choices: Array<{ id: number, name: string, satisfaction_value: number }> } };


export const UpdateCustomQuestionDocument = gql`
    mutation UpdateCustomQuestion($questionId: Int!, $name: String, $choices: [String!]) {
  updateCustomQuestion(questionId: $questionId, name: $name, choices: $choices) {
    id
    isUsed
    name
    choices {
      id
      name
      satisfaction_value
    }
  }
}
    `;

/**
 * __useUpdateCustomQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateCustomQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomQuestionMutation, { data, loading, error }] = useUpdateCustomQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      name: // value for 'name'
 *      choices: // value for 'choices'
 *   },
 * });
 */
export function useUpdateCustomQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomQuestionMutation, UpdateCustomQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomQuestionMutation, UpdateCustomQuestionMutationVariables>(UpdateCustomQuestionDocument, options);
      }
export type UpdateCustomQuestionMutationHookResult = ReturnType<typeof useUpdateCustomQuestionMutation>;
export type UpdateCustomQuestionMutationResult = Apollo.MutationResult<UpdateCustomQuestionMutation>;
export type UpdateCustomQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateCustomQuestionMutation, UpdateCustomQuestionMutationVariables>;